export interface User {
  id: number;
  nome: string;
  role: string;
  roleId?: number;
  ativo: boolean;
  ultimoLogin?: string;
}

export interface LoginRequest {
  nome: string;
  password: string;
  rememberMe: boolean;
}

export interface LoginResponse {
  nome: string;
  role: string;
  roleId: number;
  utilizadorId: number;
}

export interface MeResponse {
  id: number;
  nome: string;
  role: string;
  roleId: number;
  ativo: boolean;
  ultimoLogin?: string;
}

export interface ApiResponse<T> {
  success: boolean;
  data?: T;
  message?: string;
  errorCode?: string;
}

export interface PagedResult<T> {
  items: T[];
  totalCount: number;
  page: number;
  pageSize: number;
  totalPages: number;
}

export interface Local {
  id: number;
  descricao: string;
  cor: string;
  mesaInicio: number;
  mesaFim: number;
  capacidadePadrao: number;
  versao: number;
}

export interface CreateLocalRequest {
  descricao: string;
  cor: string;
  mesaInicio: number;
  mesaFim: number;
  capacidadePadrao: number;
}

export interface UpdateLocalRequest {
  descricao: string;
  cor: string;
  mesaInicio: number;
  mesaFim: number;
  capacidadePadrao: number;
  versao: number;
}

export interface Mesa {
  id: number;
  localId: number;
  localDescricao: string;
  localCor: string;
  descricao: string;
  numero: number;
  capacidadePessoas: number;
  podeReservar: boolean;
  mesaDefault: boolean;
  versao: number;
}

export interface CreateMesaRequest {
  localId: number;
  descricao: string;
  numero: number;
  capacidadePessoas: number;
  podeReservar: boolean;
  mesaDefault: boolean;
}

export interface UpdateMesaRequest {
  localId: number;
  descricao: string;
  numero: number;
  capacidadePessoas: number;
  podeReservar: boolean;
  mesaDefault: boolean;
  versao: number;
}

export interface Cliente {
  id: number;
  nome: string;
  telefone?: string;
  email?: string;
  nif?: string;
  morada?: string;
  bloqueado: boolean;
  motivoBloqueio?: string;
  notas?: string;
  clienteEventual: boolean;
  versao?: number;
}

export interface CreateClienteRequest {
  nome: string;
  telefone?: string;
  email?: string;
  nif?: string;
  morada?: string;
  notas?: string;
  clienteEventual: boolean;
}

export interface UpdateClienteRequest {
  nome: string;
  telefone?: string;
  email?: string;
  nif?: string;
  morada?: string;
  notas?: string;
  versao: number;
}

export interface BloquearClienteRequest {
  bloqueado: boolean;
  motivo?: string;
  versao: number;
}

export interface Reserva {
  id: number;
  dataDaReserva: string;
  numeroPessoas: number;
  contatoReserva?: string;
  notasReserva?: string;
  nomeCliente?: string;
  reservaFechada: boolean;
  reservaCancelada: boolean;
  clienteId?: number;
  cliente?: Cliente;
  mesaId?: number;
  mesa?: Mesa;
  valor?: number;
  canalId?: number;
  canal?: Canal;
  criadoPorNome?: string;
  editadoPorNome?: string;
  versao: number;
}

export interface CreateReservaRequest {
  dataDaReserva: string;
  numeroPessoas: number;
  contatoReserva?: string;
  notasReserva?: string;
  nomeCliente?: string;
  clienteId?: number;
  mesaId?: number;
  valor?: number;
  canalId?: number;
}

export interface UpdateReservaRequest {
  dataDaReserva: string;
  numeroPessoas: number;
  contatoReserva?: string;
  notasReserva?: string;
  nomeCliente?: string;
  clienteId?: number;
  mesaId?: number;
  valor?: number;
  canalId?: number;
  versao: number;
}

export interface ConfirmarCancelarReservaRequest {
  versao: number;
}

export interface ReservaListFilter {
  data?: string;
  apenasHoje?: boolean;
  incluirCanceladas?: boolean;
  incluirFechadas?: boolean;
  page: number;
  pageSize: number;
}

export interface HistoricoMesa {
  id: number;
  origem: number;
  dataMesa: string;
  numeroPessoas: number;
  valor: number;
  pago: boolean;
  encerrado?: boolean;
  dataSaida?: string;
  contatoReserva?: string;
  notasMesa?: string;
  clienteId?: number;
  cliente?: Cliente;
  mesaId: number;
  mesa?: Mesa;
  reservaId?: number;
  reserva?: Reserva;
  versao: number;
}

export interface CreateHistoricoMesaRequest {
  origem: number;
  dataMesa: string;
  numeroPessoas: number;
  valor: number;
  pago: boolean;
  contatoReserva?: string;
  notasMesa?: string;
  clienteId?: number;
  mesaId: number;
  reservaId?: number;
}

export interface UpdateHistoricoMesaRequest {
  origem: number;
  dataMesa: string;
  numeroPessoas: number;
  valor: number;
  pago: boolean;
  contatoReserva?: string;
  notasMesa?: string;
  clienteId?: number;
  mesaId: number;
  reservaId?: number;
  versao: number;
}

export interface Configuracao {
  id: number;
  chave: string;
  valor: string;
  descricao?: string;
  versao?: number;
}

export interface CreateConfiguracaoRequest {
  chave: string;
  valor: string;
  descricao?: string;
}

export interface UpdateConfiguracaoRequest {
  valor: string;
  descricao?: string;
  versao: number;
}

export interface Canal {
  id: number;
  descricao: string;
  isDefault: boolean;
  ativo: boolean;
  versao: number;
}
export interface CreateCanalRequest {
  descricao: string;
  isDefault?: boolean;
  ativo?: boolean;
}
export interface UpdateCanalRequest {
  descricao: string;
  isDefault: boolean;
  ativo: boolean;
  versao: number;
}

export interface Utilizador {
  id: number;
  nome: string;
  role: string;
  ativo: boolean;
  ultimoLogin?: string;
  versao: number;
}

export interface CreateUtilizadorRequest {
  nome: string;
  password: string;
  role: string;
  ativo: boolean;
}

export interface UpdateUtilizadorRequest {
  nome: string;
  password?: string;
  role: string;
  ativo: boolean;
  versao: number;
}

export interface MapaMesa {
  id: number;
  localId: number;
  localDescricao: string;
  localCor: string;
  descricao: string;
  numero: number;
  capacidadePessoas: number;
  podeReservar: boolean;
  estado: number; // 0=Livre, 1=Reservada, 2=Ocupada, 3=ChegaAgora
  estadoDescricao: string;
  reservaAtiva?: Reserva;
  reservasAtivas?: Reserva[];
  ultimoHistorico?: HistoricoMesa;
}

export interface LocalBillingDto { localId: number; localDescricao: string; previsto: number; fechado: number; }
export interface MapaMesasResponse {
  data: string;
  mesas: MapaMesa[];
  billingPorLocal?: LocalBillingDto[];
}

export interface Auditoria {
  id: number;
  tabela: string;
  registoId: number;
  acao: number;
  acaoDescricao: string;
  dados: string;
  utilizadorId: number;
  utilizadorNome: string;
  data: string;
}

export interface AuditoriaFilter {
  tabela?: string;
  registoId?: number;
  dataInicio?: string;
  dataFim?: string;
  page: number;
  pageSize: number;
}

export enum MesaEstado {
  Livre = 0,
  Reservada = 1,
  Ocupada = 2,
  ChegaAgora = 3,
}

export enum ReservaOrigem {
  Normal = 0,
  Reserva = 10,
}

export enum AuditoriaAcao {
  Criar = 1,
  Editar = 2,
  Cancelar = 3,
  Confirmar = 4,
  Eliminar = 5,
}

export interface RoleDto {
  id: number;
  nome: string;
  descricao?: string;
  ativo: boolean;
  versao: number;
}

export interface PermissaoDto {
  id: number;
  role: number;
  recurso: string;
  podeAceder: boolean;
  podeCriar: boolean;
  podeEditar: boolean;
  podeEliminar: boolean;
  podeGerir: boolean;
  versao: number;
}

export interface EstatisticasResumo {
  totalReservas: number;
  canceladas: number;
  fechadas: number;
  ativas: number;
  totalPessoasReservas: number;
  totalPessoasHistorico: number;
  valorPrevisto: number;
  valorPago: number;
  valorPerdidoCanceladas: number;
  ticketMedioPrevisto: number;
  ticketMedioPago: number;
  taxaCancelamento: number;
  taxaConversao: number;
  totalOcupacoes: number;
  ocupacoesPagas: number;
  ocupacoesPendentes: number;
  totalPessoasOcupacoes: number;
  valorOcupacoes: number;
  valorOcupacoesPago: number;
  ticketMedioOcupacoes: number;
}
export interface EstatisticasPorDia { data: string; reservas: number; pessoas: number; valorPrevisto: number; valorPago: number; canceladas: number; ocupacoes: number; pessoasOcupacoes: number; valorOcupacoes: number; valorOcupacoesPago: number; }
export interface EstatisticasPorCanal { canalId: number | null; descricao: string; reservas: number; pessoas: number; valor: number; percentagem: number; }
export interface EstatisticasPorLocal { localId: number; descricao: string; cor: string; reservas: number; pessoas: number; valorPrevisto: number; valorPago: number; ocupacoes: number; pessoasOcupacoes: number; valorOcupacoes: number; valorOcupacoesPago: number; }
export interface EstatisticasPorHora { hora: number; reservas: number; pessoas: number; valor: number; ocupacoes: number; pessoasOcupacoes: number; valorOcupacoes: number; }
export interface EstatisticasResponse {
  inicio: string;
  fim: string;
  resumo: EstatisticasResumo;
  porDia: EstatisticasPorDia[];
  porCanal: EstatisticasPorCanal[];
  porLocal: EstatisticasPorLocal[];
  porHora: EstatisticasPorHora[];
}